import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function MaricopaPage() {
  return <LocationPageTemplate city="Maricopa" cityShort="Maricopa" slug="maricopa" data-id="element-1016" />;
}